var user = {
  "fields": {
    "id": {
      "name": "id",
      "type": "ID",
      "readonly": 3,
      "options": null
    },
    "email": {
      "name": "email",
      "type": "STRING",
      "readonly": false,
      "options": null
    },
    "password": {
      "name": "password",
      "type": "STRING",
      "readonly": false,
      "options": null
    },
    "nick": {
      "name": "nick",
      "type": "STRING",
      "readonly": false,
      "options": null
    },
    "name": {
      "name": "name",
      "type": "STRING",
      "readonly": false,
      "options": null
    },
    "created": {
      "name": "created",
      "type": "DATETIME",
      "readonly": false,
      "options": null
    },
    "login": {
      "name": "login",
      "type": "DATETIME",
      "readonly": false,
      "options": null
    },
    "termsAccepted": {
      "name": "termsAccepted",
      "type": "INT",
      "readonly": false,
      "options": null
    },
    "group": {
      "name": "group",
      "type": "ENUM",
      "readonly": false,
      "options": ["anonymized", "visitor", "social", "moderator", "admin", "boss"]
    },
    "guid": {
      "name": "guid",
      "type": "GUID",
      "readonly": 3,
      "options": null
    },
    "favoriteIds": {
      "name": "favoriteIds",
      "type": "JSON",
      "readonly": false,
      "options": null
    }
  },
  "attachments": {
    "avatar": {
      "name": "avatar",
      "extensions": ["png", "jpg", "gif"],
      "maxFileCount": 1,
      "maxFileSize": 5120000,
      "meta": null
    },
    "header": {
      "name": "header",
      "extensions": ["png", "jpg", "gif"],
      "maxFileCount": 1,
      "maxFileSize": 5120000,
      "meta": null
    }
  },
  "relations": {
    "name": "favorites",
    "descriptor": {
      "ghost": "Application\\Ghost\\Article",
      "field": "favoriteIds"
    },
    "type": "belongsToMany"
  }
};
export default user;